import { Trans } from '../../atoms'
import { priceNotation } from '../../../utils/safe'

const OrdineTotale = ({ ordine, ordine_db }) => {
  return (
    <>
      <div className="ordine-totale">
        <h3 className="ordine-totale__title">
          <Trans chiave="Totali ordine" />
        </h3>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="Valore merce (inclusa eventuale Siae):" />
          </span>
          <span>{priceNotation(ordine.valoreMerce + ordine.valoreSpeseSiae, 2)} €</span>
        </div>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="Costo personalizzazione (incluso eventuale confezionamento):" />
          </span>
          <span>
            {priceNotation(ordine.valorePersonalizzazione + ordine.valoreConfezionamento, 2)} €
          </span>
        </div>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="Costo impianti, avviamento e tracciatura logo:" />
          </span>
          <span>
            {priceNotation(
              ordine.valoreImpianto + ordine.valoreGestione + ordine.valoreTracciaturaLogo,
              2
            )}{' '}
            €
          </span>
        </div>
        {ordine?.valoreSupplementiMinimiDiStampa > 0 && (
          <div className="ordine-totale__row">
            <span>
              <Trans chiave="Costo supplementi minimi di stampa:" />
            </span>
            <span>{priceNotation(ordine.valoreSupplementiMinimiDiStampa, 2)} €</span>
          </div>
        )}
        <div className="ordine-totale__row">
          {ordine_db?.valore_ritiro ? (
            <>
              <span>
                <Trans chiave="Costo ritiro:" />
              </span>
              <span>{priceNotation(ordine_db.valore_ritiro, 2)} €</span>
            </>
          ) : (
            <>
              <span>
                <Trans chiave="Costo spedizione:" />
              </span>
              <span>{priceNotation(ordine.valoreTrasporto, 2)} €</span>
            </>
          )}
        </div>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="Sconti" />{":"}
          </span>
          <span>
            {priceNotation(
              ordine.valoreScontoImballi +
                ordine.valoreScontoMerce +
                ordine.valoreScontoPersonalizzazione +
                ordine.valoreScontoGestione +
                ordine.valoreScontoImpianto +
                ordine.valoreScontoTrasporto,
              2
            )}{' '}
            €
          </span>
        </div>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="Totale imponibile:" />
          </span>
          <span>{priceNotation(ordine.totaleImponibile, 2)} €</span>
        </div>
        <div className="ordine-totale__row">
          <span>
            <Trans chiave="IVA:" />
          </span>
          <span>{priceNotation(ordine.totaleIva, 2)} €</span>
        </div>
        <div className="ordine-totale__row ordine-totale__row--big">
          <span>
            <Trans chiave="Totale complessivo:" />
          </span>
          <span>{priceNotation(ordine.totaleDocumento, 2)} €</span>
        </div>
      </div>
    </>
  )
}

export default OrdineTotale
